export default {
    associate_to_gps_title: "Associate camera to gps device",
    associate_to_gps_success_message: "Devices have been paired",
    associate_to_gps_error_message: "The device manufacturer must be different from VidFleet and SmartWitness",
    associate_to_gps_vidfleet_device_esn: "Camera ESN",
    associate_to_gps_search_gps_device: "Search a GPS Device",
    associate_to_gps_alert_message: "The device is already paired to another device, if you continue with the action it will be unpaired automatically",
    associate_to_gps_pair: "Pair",
    associate_to_gps_search_by: "Search a GPS Device by Device Name, ESN, IMEI",
}